import * as React from 'react';
import snakeCase from 'lodash/snakeCase';

import PopoverList from 'components/popover-list/PopoverList';
import MixedSelectDropdown from 'components/inputs/mixed-select-dropdown/MixedSelectDropdown';

import { __t, applyTranslations } from 'utils/language';

import './sov-kpi-selector.scss';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('modules/insights/sov/shared/sov-shared.i18n.json'));

import type {
  Data,
  MixedSelectDropdownItem,
  SelectOption
} from 'types';

type Props = {
  label: string,
  options: Array<SelectOption>,
  value: string,
  onChange: (value: string) => void
};

const COMMON_MSG_KEY = 'collabary_common';
const MSG_KEY = 'sov_shared';

const SOVKpiSelector = ({
  label,
  options,
  value,
  onChange
}: Props): JSX.Element => {
  const dropdownItems: Array<MixedSelectDropdownItem> = options
    .map(item => ({
      identifier: item.value,
      isDisabled: false,
      isSelected: value === item.value,
      label: item.label,
      value: item.value
    }));

  const handleChange = (
    updatedItems: Array<MixedSelectDropdownItem>,
    data?: Data | null,
    selectedItem?: Partial<MixedSelectDropdownItem> | null
  ): void => (
    onChange(selectedItem?.identifier || updatedItems[0].identifier)
  );

  return (
    <form className="sov-kpi-selector">
      <span className="sov-kpi-selector__label">
        {label}:
      </span>
      <div className="sov-kpi-selector__tooltip">
        <PopoverList
          list={options.map(option => ({
            title: __t(`${COMMON_MSG_KEY}.kpis.${snakeCase(option.value)}`),
            body: __t(`${MSG_KEY}.tooltips.${snakeCase(option.value)}`)
          }))}
        />
      </div>
      <MixedSelectDropdown
        key={`sov-kpi-selector__dropdown--${value}`}
        name="sov-kpi-selector__dropdown"
        items={dropdownItems}
        withSelectedInList
        className="sov-kpi-selector__dropdown"
        onItemsToggle={handleChange}
      />
    </form>
  );
};

export default SOVKpiSelector;
